import React from "react";
import { useNavigate } from "react-router-dom";
import { Search, PenLine, Flower2, MailPlus } from "lucide-react";
import { Petals } from "@/components/Petals";

const STEPS = [
  { n: "01", icon: Search, title: "Explore the Wall", desc: "Browse love notes left alphabetically for members, or search any recipient freely — no login needed." },
  { n: "02", icon: PenLine, title: "Craft Your Note", desc: "Write a heartfelt message. Stay completely anonymous or sign your name, and add a sweet picture." },
  { n: "03", icon: Flower2, title: "Attach Roses (99p)", desc: "Pick Pink, White or Red. Mix up to 3 to bloom a stunning bouquet backdrop behind your note." },
  { n: "04", icon: MailPlus, title: "Connect Privately", desc: "Toggle your profile to share an email or accept in-app messages when someone leaves you a rose." },
];

export default function HowItWorks() {
  const navigate = useNavigate();
  return (
    <div className="garden-bg">
      <Petals count={8} />
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10 pt-16 pb-8 text-center">
        <p className="text-xs font-mono tracking-[0.3em] uppercase text-pink-400 mb-4">The ritual</p>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-pink-50 text-glow">How the Garden works</h1>
        <p className="max-w-2xl mx-auto mt-6 text-base sm:text-lg text-slate-300 leading-relaxed">
          Four gentle steps from a quiet thought to a rose in full bloom.
        </p>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10 py-8 space-y-6">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div
              key={s.n}
              data-testid={`how-step-${s.n}`}
              className="flex items-start gap-6 card-glass rounded-2xl p-6 sm:p-8 border border-pink-500/20 float-up"
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="flex-shrink-0">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-pink-600 to-rose-500 flex items-center justify-center shadow-lg shadow-pink-500/25">
                  <Icon className="w-6 h-6 text-white" />
                </div>
              </div>
              <div>
                <div className="flex items-baseline gap-3">
                  <span className="font-mono text-pink-400 text-sm">{s.n}</span>
                  <h3 className="font-serif text-2xl text-pink-100">{s.title}</h3>
                </div>
                <p className="text-slate-400 mt-2 leading-relaxed">{s.desc}</p>
              </div>
            </div>
          );
        })}

        <div className="text-center pt-6">
          <button
            data-testid="how-cta-btn"
            onClick={() => navigate("/")}
            className="bg-gradient-to-r from-pink-600 to-rose-500 hover:from-pink-500 hover:to-rose-400 text-white font-medium px-7 py-3.5 rounded-full shadow-lg shadow-pink-500/25 transition-all hover:scale-105"
          >
            Enter the Garden
          </button>
        </div>
      </section>
    </div>
  );
}
